import { render } from "./PieChartCt.vue?vue&type=template&id=22ecaf9b&scoped=true"
import script from "./PieChartCt.vue?vue&type=script&lang=js"
export * from "./PieChartCt.vue?vue&type=script&lang=js"

import "./PieChartCt.vue?vue&type=style&index=0&id=22ecaf9b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ecaf9b"]])

export default __exports__